import * as types from "./actionTypes";

export const AddFamilyMember = (data) => {
  return {
    type: types.ADD_FAMILY_MEMBER,
    payload: data,
  };
};
